import carData from "./CarDataStore";
import auth from "./AuthStore";

import workflow from "./WorkflowStore";
import settings from "./SettingsStore";
import payment from "./PaymentStore";
import stashedProductData from "./StashedProductDataStore";
import profile from "./ProfileStore";

// const ls = typeof document !== "undefined" ? window.localStorage : null;
// if (ls) {
//  ls.clear();
// }
const stores = {
  carData,
  auth,
  workflow,
  settings,
  payment,
  stashedProductData,
  profile
};

export default stores;
